import GATSBY_COMPILED_MDX from "D:/React JS/Products/peerbits-react-website-new/content/blog/process-of-hiring-dedicated-developers/index.mdx";
import React, {useEffect, useState} from "react";
import {Link, graphql} from "gatsby";
import Seo from "../components/seo";
import {AuthorDefault} from "../utils/imageConst";
import {Container, Col, Row, Image} from 'react-bootstrap';
import {GatsbyImage, getSrc, getImage} from "gatsby-plugin-image";
import SocialShare from "../components/social-share";
import {AnchorLink} from "gatsby-plugin-anchor-links";
import BlogSubscribe from "../components/blog/blog-subscribe-form";
import Scrollspy from "react-scrollspy";
import Layout from "../components/layout/layout";
import {MDXProvider} from "@mdx-js/react";
export const Head = ({data}) => {
  const post = data.mdx.frontmatter;
  const socialImg = getSrc(post?.socialImage);
  return React.createElement(Seo, {
    title: post.metaTitle || post.title,
    description: post.metaDescription,
    ogImage: socialImg,
    twitterImage: socialImg
  });
};
const BlogMdxSingle = ({data: {site, allMdx, mdx: post}, children}) => {
  const socialUrl = typeof window !== 'undefined' ? window.location.href : '';
  const anchorLinkBlank = {
    a: props => {
      const isInternalLink = props.href?.startsWith("#");
      return React.createElement("a", Object.assign({}, props, {
        target: isInternalLink ? "" : "_blank",
        "aria-label": "anchor link"
      }));
    }
  };
  const author = post.frontmatter?.author;
  const siteinfo = site?.siteMetadata;
  const posts = allMdx?.nodes;
  const curCat = post.frontmatter?.categories;
  const titletagline = post.frontmatter?.titletagline;
  const curTitle = post.frontmatter?.title;
  const url = post.tableOfContents?.items?.map(tag => tag?.url?.substring(1));
  const imageAuth = getImage(author?.img);
  let categoriesFound = [];
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 300);
    });
  }, []);
  posts.map(post => post?.frontmatter?.categories.map(category => {
    return categoriesFound.indexOf(category) === -1 ? categoriesFound.push(category) : null;
  }));
  return React.createElement(React.Fragment, null, React.createElement(Layout, {
    headerClass: "navbar-light"
  }, React.createElement("section", {
    className: "section blog-post-header bg-light pb-4"
  }, React.createElement("div", {
    className: "pt-5 mt-lg-4 container text-center"
  }, React.createElement("div", {
    className: "category-single-post mb-4"
  }, post?.frontmatter?.categories?.map((category, index) => React.createElement(Link, {
    key: index,
    to: `/blog/category/${category.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`,
    rel: "category tag",
    className: "category text-black force-hover badge fw-normal"
  }, category, " ", React.createElement("i", {
    className: "coma-sep"
  }, ", ")))), React.createElement("h1", {
    className: "font-size-40 mb-4"
  }, post?.frontmatter?.title), React.createElement("p", {
    className: "subline lead mb-0 max-width-950 mx-auto fw-italic"
  }, titletagline), React.createElement("div", {
    className: `py-3 blog-single-title text-start ${scroll ? "blog-title-fixed" : ""}`
  }, React.createElement(Container, null, React.createElement("p", {
    className: "mb-0 h4 title"
  }, post?.frontmatter?.title))), React.createElement("div", {
    className: "single-line-meta border-bottom mb-4"
  }, React.createElement("ul", {
    className: "list-inline fw-medium my-4 d-flex flex-wrap align-items-center justify-content-center"
  }, React.createElement("li", {
    className: "list-inline-item mx-4"
  }, React.createElement("div", {
    className: "author-top"
  }, React.createElement(Link, {
    to: `/blog/author/${author?.name ? author?.name : siteinfo?.author}`.toLowerCase().replace(/ /g, "-"),
    className: "author-image mb-3"
  }, author?.img ? React.createElement(GatsbyImage, {
    loading: "lazy",
    className: "bio-avatar",
    image: imageAuth,
    width: 72,
    height: 72,
    alt: "author-profile"
  }) : React.createElement(Image, {
    loading: "lazy",
    className: "bio-avatar lazyload",
    src: AuthorDefault,
    width: 72,
    height: 72,
    alt: "author-profile"
  })), React.createElement("div", {
    className: "author-content"
  }, React.createElement("h3", {
    className: "author-name font-size-16 mb-1"
  }, React.createElement(Link, {
    to: `/blog/author/${author?.name ? author?.name : siteinfo?.author}`.toLowerCase().replace(/ /g, "-"),
    className: "authLink"
  }, author?.name ? author?.name : siteinfo?.author)), React.createElement("p", {
    className: "author-info fw-normal font-size-14"
  }, author?.tagline ? author?.tagline : siteinfo?.authorTagLine)))))), React.createElement("div", {
    className: "single-line-meta"
  }, React.createElement("ul", {
    className: "list-inline font-size-14 mb-0 d-flex align-items-center justify-content-space-between flex-wrap"
  }, React.createElement("li", {
    className: "list-inline-item me-auto"
  }, React.createElement("div", {
    className: "d-flex align-items-center"
  }, React.createElement("i", {
    className: "zmdi zmdi-refresh me-2"
  }), "Last Updated on ", post.frontmatter?.modifyDate ? post.frontmatter?.modifyDate : post.frontmatter?.date)), React.createElement("li", {
    className: "list-inline-item"
  }, React.createElement("div", {
    className: "d-flex align-items-center"
  }, React.createElement("i", {
    className: "zmdi zmdi-time me-2"
  }), post?.fields?.timeToRead?.text)))))), React.createElement("section", {
    className: "blog-post-section section"
  }, React.createElement(Container, {
    className: "pb-5"
  }, React.createElement("div", {
    className: "blog-post-container"
  }, React.createElement("div", {
    className: "social-share"
  }, React.createElement("p", {
    className: "font-size-14"
  }, "SHARE"), React.createElement(SocialShare, {
    url: socialUrl,
    title: post?.frontmatter.title,
    description: post?.frontmatter.excerpt
  })), React.createElement(Row, {
    className: "g-5"
  }, React.createElement(Col, {
    lg: 8
  }, React.createElement("div", {
    className: "blog-post-content"
  }, React.createElement(MDXProvider, {
    components: anchorLinkBlank
  }, children)), React.createElement("div", {
    className: "author d-block d-md-flex align-items-start"
  }, React.createElement("div", {
    className: "author-image pe-4 mb-4 mb-md-0"
  }, author?.img ? React.createElement(GatsbyImage, {
    loading: "lazy",
    className: "bio-avatar",
    image: imageAuth,
    width: 72,
    height: 72,
    alt: "author-profile"
  }) : React.createElement(Image, {
    loading: "lazy",
    className: "bio-avatar lazyload",
    src: AuthorDefault,
    width: 72,
    height: 72,
    alt: "author-profile"
  })), React.createElement("div", {
    className: "author-content"
  }, React.createElement("h3", {
    className: "author-name h5"
  }, React.createElement(Link, {
    to: `/blog/author/${author?.name ? author?.name : siteinfo?.author}`.toLowerCase().replace(/ /g, "-"),
    className: "authLink"
  }, author?.name ? author?.name : siteinfo?.author)), React.createElement("p", {
    className: "author-info"
  }, author?.description ? author?.description : siteinfo?.authorDescription))), React.createElement(BlogSubscribe)), React.createElement(Col, {
    lg: 4,
    className: "ps-lg-5 blog-sidebar"
  }, React.createElement("div", {
    className: "category-list mb-5 nav-tabs-link"
  }, React.createElement("h4", {
    className: "mb-4 text-muted"
  }, "Filter by Categories"), React.createElement("ul", {
    className: "list-unstyled d-flex align-items-center flex-wrap mb-0"
  }, categoriesFound.map((newCategories, index) => React.createElement("li", {
    key: index
  }, React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    "aria-label": "category",
    href: `/blog/category/${newCategories.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`
  }, newCategories))))), React.createElement("div", {
    className: "table-of-contents sticky-section"
  }, url ? React.createElement("h4", {
    className: "mb-4 text-muted"
  }, "Table of contents") : null, React.createElement(Scrollspy, {
    offset: -150,
    className: "list-unstyled toc",
    items: url,
    currentClassName: "active"
  }, post.tableOfContents?.items?.map(heading => {
    if (heading?.title !== '') {
      return React.createElement("li", {
        key: heading.url
      }, React.createElement(AnchorLink, {
        to: `${post?.frontmatter?.slug}.html${heading.url}`,
        stripHash: true
      }, heading.title));
    }
    return null;
  })))))))), React.createElement("section", {
    className: "blog-list-section section related-post bg-light"
  }, React.createElement(Container, {
    className: "py-5"
  }, React.createElement("div", {
    className: "section-title mb-5 pb-1"
  }, React.createElement("h2", {
    className: "heading mb-0"
  }, "Related Post")), React.createElement(Row, {
    xs: 1,
    lg: 3,
    className: "g-4"
  }, posts.filter(node => node?.frontmatter?.categories?.some(i => curCat?.includes(i)) && node?.frontmatter?.title !== curTitle).map((post, index) => {
    const imageReltd = getImage(post?.frontmatter?.featured);
    if (index < 3) {
      return React.createElement(Col, {
        key: index
      }, React.createElement(Link, {
        to: post?.fields?.slug,
        className: "blog-list-card single"
      }, React.createElement("div", {
        className: "blog-image"
      }, React.createElement(GatsbyImage, {
        loading: "lazy",
        width: 416,
        height: 245,
        image: imageReltd,
        alt: "featured"
      })), React.createElement("div", {
        className: "blog-list-content mt-4"
      }, React.createElement("p", {
        className: "single-line-meta text-muted mb-2 font-size-14"
      }, React.createElement("span", null, post?.frontmatter?.modifyDate)), React.createElement("h2", {
        className: "blog-title h5 fw-normal"
      }, post?.frontmatter?.title))));
    } else {
      return null;
    }
  }))))));
};
BlogMdxSingle
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogMdxSingle, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const BlogMdx = graphql`
query ($id: String!) {
  site {
    siteMetadata {
      author
      authorDescription
      authorTagLine
      social {
        twitter
      }
    }
  }
  allMdx(sort: {frontmatter: {modifyDate: DESC}}) {
    nodes {
      id
      fields {
        slug
        timeToRead {
          text
        }
      }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        modifyDate(formatString: "MMMM DD, YYYY")
        title
        categories
        featured {
          childImageSharp {
            gatsbyImageData(width: 416, height: 245)
          }
        }
      }
    }
  }
  mdx(id: {eq: $id}) {
    tableOfContents
    body
    fields {
      timeToRead {
        text
      }
    }
    frontmatter {
      date(formatString: "MMMM DD, YYYY")
      modifyDate(formatString: "MMMM DD, YYYY")
      title
      titletagline
      slug
      categories
      socialImage {
        childImageSharp {
          gatsbyImageData
        }
      }
      metaTitle
      metaDescription
      featured {
        childImageSharp {
          gatsbyImageData(width: 848)
        }
      }
      author {
        name
        description
        tagline
        img {
          childImageSharp {
            gatsbyImageData(width: 72)
          }
        }
      }
    }
  }
}`;
